import React from "react"
import { withPrefix } from 'gatsby'

const Icon = (props) => (
  <svg className={`icon ${props.class}`}>
     <use xlinkHref={withPrefix(`icons-sprite.svg#${props.iconName}`)}></use>
  </svg>
)

export default Icon